/**
 * Requires an explicit customer choice for every multi-value product option
 * before Add to Cart is enabled. Added for the 7"/10" loop size rollout so a
 * customer can never submit the pre-selected (first) variant without
 * consciously picking every meaningful option themselves.
 *
 * This theme's product page is powered by the <block-variant-picker> and
 * <block-buy-buttons> custom elements (assets/block.product-variant-picker.js
 * and assets/block.product-buy-buttons.js). Those already do the right thing
 * the moment a customer changes a value: they work out the matching variant
 * and enable/disable/relabel the Add to Cart button correctly. The only gap
 * is the very first paint, where the theme pre-selects the first value of
 * every option and therefore renders the button already enabled.
 *
 * This script only corrects that first paint. It never re-implements the
 * theme's own variant matching, and it never touches an option group that
 * only has one possible value (nothing meaningful to choose there).
 */
(function () {
  function isGroupResolved(el) {
    if (el.tagName === 'SELECT') {
      return !!el.value;
    }
    if (el.tagName === 'FIELDSET') {
      var radios = el.querySelectorAll('input[type="radio"]');
      if (radios.length <= 1) return true; // single-value option, nothing to choose
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return true;
      }
      return false;
    }
    return true;
  }

  function gateButton(picker) {
    var sectionId = picker.dataset.sectionId;
    if (!sectionId) return;
    var form = document.getElementById('product-form-' + sectionId);
    if (!form) return;
    var button = form.querySelector('[name="add"]');
    if (!button) return;
    var textEl = button.querySelector('span');
    button.setAttribute('disabled', 'disabled');
    if (textEl) textEl.textContent = 'Select options';
  }

  function initPicker(picker) {
    var groups = picker.querySelectorAll('fieldset, select');
    for (var i = 0; i < groups.length; i++) {
      if (!isGroupResolved(groups[i])) {
        gateButton(picker);
        return;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('block-variant-picker').forEach(initPicker);
  });
})();
